import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icn-double-chevron",
  "use": "icon-icn-double-chevron-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"icon-icn-double-chevron\"><path d=\"M-1-1h12v12H-1z\" /><g><path stroke=\"null\" d=\"M2.458 5.007l1.89 2.908H3.315l-2.16-2.842v-.139l2.16-2.849h1.033l-1.89 2.922zm4.498 0l1.89 2.908H7.811l-2.16-2.842v-.139l2.16-2.849h1.033l-1.89 2.922z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol